import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './index.scss';

export default function Tab({ tabs, isZenoti, selected, onTabChange }) {
  return (
    <div className={classnames("tab-bar",{'zentoi-tab':isZenoti})}>
      {tabs.map((tab) => {
        return (
          <button
            className={classnames('tab-bar__tabs', {
              'tab-bar__tabs--done': tab.isComplete,
              'tab-bar__tabs--selected': selected === tab.value,
            })}
            onClick={() => {
              return tab.isComplete ? onTabChange(tab.value) : null;
            }}
            key={tab.value}
          >
            {tab.value}. {tab.text}
          </button>
        );
      })}
    </div>
  );
}

Tab.defaultProps = {
  tabs: [],
  selected: 1,
  onTabChange: () => {},
};

Tab.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.object),
  selected: PropTypes.number,
  onTabChange: PropTypes.func,
};
